import './home-page.scss';

import NiceModal from '@ebay/nice-modal-react';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from '@/app/store/hooks';
import { gameMetaActions } from '@/entities/game';
import { MODALS } from '@/shared/config/modals';

import { GameList } from './ui/GameList';
import { type PromoBannerData, PromoSlider } from './ui/PromoSlider';
import { WinsMarquee } from './ui/WinsMarquee';

export function HomePage() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(gameMetaActions.fetchRequest());
  }, [dispatch]);

  const promoBanners = useMemo<PromoBannerData[]>(
    () => [
      {
        id: 'welcome',
        badge: t('home.promoBadgeWelcome'),
        title: t('home.promoTitleWelcome'),
        subtitle: t('home.promoSubWelcome'),
        onClick: () => NiceModal.show(MODALS.DEPOSIT),
      },
      {
        id: 'reload',
        badge: t('home.promoBadgeReload'),
        title: t('home.promoTitleReload'),
        subtitle: t('home.promoSubReload'),
        onClick: () => NiceModal.show(MODALS.WITHDRAW),
      },
      {
        id: 'cashback',
        badge: t('home.promoBadgeCashback'),
        title: t('home.promoTitleCashback'),
        subtitle: t('home.promoSubCashback'),
        onClick: () => NiceModal.show(MODALS.WITHDRAW),
      },
    ],
    [t],
  );

  return (
    <div className="home-page">
      <PromoSlider banners={promoBanners} />

      <div className="home-page__header">
        <h1 className="home-page__title">{t('home.chooseYourGame')}</h1>
        <p className="home-page__subtitle">{t('home.pickAGame')}</p>
      </div>

      <WinsMarquee />

      <GameList />
    </div>
  );
}
